/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_HOLDER_POLICY_LIST = gql`
  query GetPolicyList($getListOfPoliciesInput2: GetListOfPoliciesInput) {
    getListOfPolicies(input: $getListOfPoliciesInput2) {
      data {
        premium
        policyNumber
        countryToBeInsured
        policyId
        purchasedAt
        payments {
          comment
          amount
          currency
          from
        }
        coverage
        purchasedBy {
          firstName
          email
          lastName
          image
          vuid
        }
        type
        productDefination
        provisionalPolicyNumber
        benificiaryDetail {
          address {
            addressLine1
            addressLine2
            city
            country
            state
          }
          email
          firstName
          lastName
          mobileNo
        }
        useOfProceeds {
          selected
          value
        }
      }
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
`;
